"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogSetReview = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var branch_use_case_summary_1 = require("./branch_use_case_summary");
var react_2 = require("@nextui-org/react");
var product_set_1 = require("./product_set");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var get_menu_concept_thunk_1 = require("../../../../../reducers/slices/menuConcepts/thunks/get_menu_concept_thunk");
var get_products_menu_concepts_thunk_1 = require("../../../../../reducers/slices/menuConcepts/thunks/get_products_menu_concepts_thunk");
var CatalogSetReview = function (_a) {
    var step = _a.step, goToStep = _a.goToStep;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var menu_concept_id = (0, react_router_dom_1.useParams)().menu_concept_id;
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.menuConceptState; }), selectedMenuConcept = _b.selectedMenuConcept, pagination = _b.pagination;
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    (0, react_1.useEffect)(function () {
        if (!(selectedMenuConcept === null || selectedMenuConcept === void 0 ? void 0 : selectedMenuConcept._id) && menu_concept_id) {
            dispatch((0, get_menu_concept_thunk_1.get_menu_concept_thunk)({ _id: menu_concept_id, client_id: user === null || user === void 0 ? void 0 : user.client_id }));
            dispatch((0, get_products_menu_concepts_thunk_1.get_products_menu_concepts_thunk)(__assign(__assign({}, pagination), { menu_concept_id: menu_concept_id })));
        }
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-4" }, { children: [(0, jsx_runtime_1.jsx)(branch_use_case_summary_1.BranchUseCaseSummary, {}), (0, jsx_runtime_1.jsx)(product_set_1.ProductSet, {}), (0, jsx_runtime_1.jsx)(react_2.Button, __assign({ color: "primary", onClick: function () {
                    goToStep(step - 2);
                }, variant: "light", className: "w-full border-dashed border-2 border-borders" }, { children: "+ Add More Products" })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex justify-between" }, { children: [(0, jsx_runtime_1.jsx)(react_2.Button, __assign({ onClick: function () {
                            goToStep(step - 1);
                        } }, { children: "Back" })), (0, jsx_runtime_1.jsx)(react_2.Button, __assign({ color: "primary", onClick: function () {
                            goToStep(step + 1);
                        } }, { children: "Save" }))] }))] })));
};
exports.CatalogSetReview = CatalogSetReview;
